import { Button, Col, Input, message, Result, Row, Space } from "antd";
import { Controller, useForm } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";
import { Api } from "../api";
import { useSubmitForm } from "../helpers/forms";
import { useLoadFormData } from "../hooks/useLoadFormData";
import { FieldErrorMessage } from "./FieldErrorMessage";
import FileUploadV2 from "./fileUploadV2/FileUploadV2";

const GuideCategoryForm = () => {
  let { id }: any = useParams();
  // const [notFound, setNotFound] = useState(false);
  const {
    handleSubmit,
    control,
    reset,

    formState: { errors },
  } = useForm();
  let history = useHistory();
  const onSuccess = () => {
    message.success("Saved");
    history.push("/guideCategories");
  };
  // const imageFields = [
  //     {
  //         name: "image",
  //         singleValue: true,
  //         required: false
  //     }
  // ];

  const [notFound, loading] = useLoadFormData({
    apiCall: Api.guideCategories.single,
    id,
    setValue: reset,
    // imageFields
  });
  const [loadingSubmit, submit] = useSubmitForm({
    createApiCall: Api.guideCategories.create,
    updateApiCall: Api.guideCategories.update,
    onSuccess,
    // imageFields,
    updateId: id,
  });

  if (notFound)
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, document does not exist"
        extra={
          <Button type="primary">
            <Link to="/guideCategories">Back to list</Link>
          </Button>
        }
      />
    );

  return (
    <form className="white-container" onSubmit={handleSubmit(submit)}>
      <Space size="middle" style={{ width: "100%" }} direction="vertical">
        <Row style={{ width: "100%" }} gutter={12}>
          <Col span={6}>
            <label htmlFor={"name"}>Name</label>
            <Controller
              control={control}
              render={({ field }) => <Input {...field} />}
              rules={{ required: true }}
              name="name"
            />
            <FieldErrorMessage errors={errors} name="name" />
          </Col>
        </Row>
        <Row gutter={6}>
          <Col span={12}>
            <label htmlFor={"image"}>Image</label>
            <Controller
              control={control}
              render={({ field }) => <FileUploadV2 singleValue {...field} />}
              name={`image`}
            />
            <FieldErrorMessage errors={errors} name="image" />
          </Col>
        </Row>
        <Row gutter={6}>
          <Col span={12}>
            <label htmlFor={"mapIconV2"}>Map Icon</label>
            <Controller
              control={control}
              render={({ field }) => <FileUploadV2 singleValue {...field} />}
              name={`mapIconV2`}
            />
            <FieldErrorMessage errors={errors} name="mapIconV2" />
          </Col>
        </Row>
        
        <Row gutter={6}>
          <Col span={12}>
            <label htmlFor={"icon"}>Icon</label>
            <Controller
              control={control}
              render={({ field }) => <FileUploadV2 singleValue {...field} />}
              name={`icon`}
            />
            <FieldErrorMessage errors={errors} name="icon" />
          </Col>
        </Row>
      </Space>
      <div style={{ marginBottom: 10 }} />
      <Button loading={loading || loadingSubmit} htmlType="submit" role={"submit"}>
        Submit
      </Button>
    </form>
  );
};

export default GuideCategoryForm;
